import { IQuestion, IQuizResult } from '../components/types'
import { quiz_result_element } from '../__generated__/quiz_result'
import {
  quiz_sections_shades,
  quiz_sections_types,
} from '../__generated__/quiz_sections'
import { getCatalogElementUrl, getPropFilesByCode } from './gql'

export const createQuizQ1 = (sections: quiz_sections_shades): IQuestion => {
  if (!sections) {
    return null
  }

  const q = 'Какой у вас тон?'

  const variants = sections.nodes.map((section) => ({
    img: section.previewPicture.url,
    title: section.name,
    description: section.description,
    id: section.bx_id,
  }))

  return {
    question: q,
    variants,
  }
}
export const createQuizQ2 = (
  sections: quiz_sections_shades,
  id: number,
): IQuestion => {
  if (!sections || !id) {
    return null
  }

  const q = 'Какой у вас подтон кожи?'

  const variants = sections.nodes
    .filter((section) => section.bx_id === id)[0]
    .childSections.map((section) => ({
      img: section.previewPicture.url,
      title: section.name,
      tooltip: section.description,
      id: section.bx_id,
    }))

  return {
    question: q,
    variants,
  }
}

export const createQuizQ3 = (sections: quiz_sections_types): IQuestion => {
  if (!sections) {
    return null
  }

  const q = 'Какой у вас тип кожи?'

  const variants = sections.nodes.map((section) => {
    const files = getPropFilesByCode(section.propertyValuesRelation, 'UF_ICONS')

    const icon = files?.length ? files[0].url : null
    return {
      id: section.bx_id,
      title: section.name,
      description: section.description,
      img: icon,
    }
  })

  return {
    question: q,
    variants,
  }
}

export const createQuizQ4 = (
  sections: quiz_sections_types,
  id: number,
): IQuestion => {
  if (!sections || !id) {
    return null
  }

  const q = 'Выберите то утверждение, которое вам ближе:'

  const variants = sections.nodes
    .filter((section) => section.bx_id === id)[0]
    .childSections.map((section) => {
      const files = getPropFilesByCode(
        section.propertyValuesRelation,
        'UF_ICONS',
      )

      const icon = files?.length ? files[0].url : null
      return {
        id: section.bx_id,
        description: section.description,
        img: icon,
      }
    })

  return {
    question: q,
    variants,
  }
}

export const createQuizResult = (element: quiz_result_element): IQuizResult => {
  if (!element) {
    return null
  }

  const product = element.propertyValuesRelation.filter(
    (val) => val.property.code === 'OFFER_ID',
  )[0]?.targetElements[0]

  const probe = element.propertyValuesRelation.filter(
    (val) => val.property.code === 'PROBNIK_ID',
  )[0]?.targetElement

  const hasProbe =
    product.propertyValuesEnum?.filter(
      (val) => val.property.code === 'HAS_PROBE',
    )[0]?.value === 'Да' || false

  const description = product.parentProduct?.previewText

  const img = product.detailPicture?.url

  const href = `${getCatalogElementUrl(product.parentProduct)}/?offer=${
    product.bx_id
  }`

  return {
    title: element.name,
    description,
    img,
    hasProbe,
    probePrice: probe?.priceBase || null,
    href,
    product,
    probe,
  }
}
